import React, { useState, useEffect } from 'react';
import Modal from './Modal';

interface PaymentModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: (paymentDate: string, useIndividualDueDates?: boolean) => void;
    selectedCount: number;
    dueDate?: string;
    title?: string;
}

const PaymentModal: React.FC<PaymentModalProps> = ({
    isOpen,
    onClose,
    onConfirm,
    selectedCount,
    dueDate,
    title = 'Marcar como Pago'
}) => {
    const [paymentDate, setPaymentDate] = useState<string | null>(null);
    const [useCurrentDate, setUseCurrentDate] = useState(true);

    useEffect(() => {
        if (isOpen) {
            if (useCurrentDate) {
                // Set to current date
                const today = new Date();
                const utcDate = new Date(Date.UTC(today.getFullYear(), today.getMonth(), today.getDate()));
                setPaymentDate(utcDate.toISOString());
            } else if (dueDate) {
                // Set to due date
                setPaymentDate(dueDate);
            }
        }
    }, [isOpen, useCurrentDate, dueDate]);

    const handleConfirm = () => {
        if (paymentDate) {
            const useIndividualDueDates = !useCurrentDate && !dueDate;
            onConfirm(paymentDate, useIndividualDueDates);
        }
    };

    const handleDateOptionChange = (option: 'current' | 'due') => {
        setUseCurrentDate(option === 'current');
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} title={title}>
            <div className="space-y-4">
                <p className="text-secondary-700">
                    Marcar {selectedCount} conta{selectedCount > 1 ? 's' : ''} como paga{selectedCount > 1 ? 's' : ''}?
                </p>

                <div className="space-y-3">
                    <div>
                        <label className="block text-sm font-medium text-secondary-700 mb-2">
                            Data do Pagamento
                        </label>

                        <div className="space-y-2">
                            <label className="flex items-center">
                                <input
                                    type="radio"
                                    name="dateOption"
                                    value="current"
                                    checked={useCurrentDate}
                                    onChange={() => handleDateOptionChange('current')}
                                    className="mr-2"
                                />
                                <span className="text-sm text-secondary-700">Data atual</span>
                            </label>

                            <label className="flex items-center">
                                <input
                                    type="radio"
                                    name="dateOption"
                                    value="due"
                                    checked={!useCurrentDate}
                                    onChange={() => handleDateOptionChange('due')}
                                    className="mr-2"
                                />
                                <span className="text-sm text-secondary-700">
                                    {dueDate ? 'Data de vencimento' : 'Data de vencimento (varia por conta)'}
                                </span>
                            </label>
                        </div>

                        {!useCurrentDate && !dueDate && (
                            <p className="text-xs text-orange-600 mt-1">
                                As contas selecionadas têm datas de vencimento diferentes. Cada conta será marcada com sua própria data de vencimento.
                            </p>
                        )}
                    </div>
                </div>

                <div className="flex justify-end space-x-2 pt-4">
                    <button onClick={onClose} className="btn-secondary">
                        Cancelar
                    </button>
                    <button
                        onClick={handleConfirm}
                        className="btn-primary bg-green-600 hover:bg-green-700 border-green-600"
                        disabled={!paymentDate}
                    >
                        Confirmar Pagamento
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default PaymentModal;
